import { render, staticRenderFns } from "./contract-protect-personal.vue?vue&type=template&id=a231409e&scoped=true"
import script from "./contract-protect-personal.vue?vue&type=script&lang=js"
export * from "./contract-protect-personal.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=a231409e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a231409e",
  null
  
)

export default component.exports